import React from 'react';
import { Navigate } from 'react-router-dom';
import { withRouter } from '../../../common/withRouter';
import withApi from '../../higherOrderComponents/withApi';

class ProductDetailsInternal extends React.Component {
  constructor() {
    super();

    this.state = {};
  }

  async componentDidMount() {
    const { match: { params: { productId } } } = this.props;
    const { api: { products: { getProduct: get } } } = this.props;
    const productData = await get(productId);
    this.setState({ productData });
  }

  render() {
    const { productData } = this.state;
    const { match: { params: { productId }, path } } = this.props;

    if (!productData) {
      return 'Loading...';
    }

    const { Type } = productData;

    if (path.includes('integration')) {
      return (<Navigate to={`/product/details/${productId}/integration`} replace />);
    }

    return (<Navigate to={`/product/details/${productId}`} replace />);
  }
}

const ProductDetails = withApi(withRouter(ProductDetailsInternal));

export default ProductDetails;